import { login } from '@/utils/auth';
import useUserStore from '@/stores/user.store';
import Image from 'next/image';

interface Props {
    className?: string;
    noIcon?: boolean;
}

const Login = ({ className, noIcon }: Props) => {
    const authv2 = useUserStore((state) => state.authv2);
    return (
        <button
            onClick={() => login()}
            className={
                (authv2 ? 'goAuth ' : '') +
                'inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-lg ' +
                'text-white text-[12px] font-bold tracking-[0.06em] cursor-pointer whitespace-nowrap ' +
                'hover:-translate-y-[1px] hover:brightness-[1.06] transition-[transform,filter] duration-150 ' +
                (className ?? '')
            }
            style={{
                background: 'linear-gradient(180deg, #3acdb1, #2bb89b)',
                boxShadow:
                    '0 6px 16px rgba(43,184,155,0.32), inset 0 1px 0 rgba(255,255,255,0.25)',
            }}
        >
            {!noIcon && (
                <Image
                    src={'/icons/steam.svg'}
                    width={16}
                    height={16}
                    alt=""
                    className="opacity-90"
                />
            )}
            LOGIN
        </button>
    );
};

export default Login;
